export default __webpack_public_path__ + "static/speed-d5919a4aff96b25bce7be9fbbe57a44d.svg";